import * as React from 'react';
import FilterBar from 'components/Forms/DataGrid/FilterBar';
import { Row, Col, Form } from 'antd';
import FilterTextbox from 'components/Forms/DataGrid/FilterTextbox';
import InfoIcon from 'components/Forms/InfoIcon';
import FilterDatePicker from 'components/Forms/DataGrid/FilterDatePicker';
import { FilterType, JoinType } from 'Core/Api/Api';
import FilterDateRangePicker from 'components/Forms/DataGrid/FilterDateRangePicker';
import FilterSelectbox from 'components/Forms/DataGrid/FilterSelectbox';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import { ClientIpoHandler } from '../../ClientIpoHandler';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
    accounts: any;

}
export default class IpoApplicationListFilterBar extends React.Component<Props, State> {
    handler: ClientIpoHandler;

  constructor(props: Props) {
    super(props);

    this.state = {
        accounts: []
    };
      this.handler = new ClientIpoHandler(props);
  }

  componentDidMount() {
      this.getAccounts();
  }

    getAccounts() {
        this.handler.GetAccounts().then(x => {
            const accounts: IFilterSelectOption[] =
                x.results?.map(y => ({
                    text: y.name + ' (' + y.jcsdNumber + ')' + ' - ' + y.broker?.shortName,
                    value: y.jcsdNumber,
                })) ?? [];
            this.setState({ accounts: accounts ?? [] });
        });
    }


  render() {
    return (
      <FilterBar>
        <Row>
                <Col xs={24} sm={14}>
            <Form.Item label="Offering" labelAlign="left">
              <FilterTextbox
                filterFields="Offering.Title"
                filterJoin={JoinType.And}
                suffix={<InfoIcon text="Search name" />}
              />
            </Form.Item>

          </Col>
                <Col xs={24} sm={10}>
                    <Form.Item label="Account" labelAlign="left">
                        <FilterSelectbox
                            filterFields="Account.JCSDNumber"
                            filterJoin={JoinType.And}
                            options={this.state.accounts}
                        />
                    </Form.Item>

          </Col>
        </Row>
      </FilterBar>
    );
  }
}



